// List of supported audio file extensions, created by both Android and iPhone audio recorders
// including audio/* and video/mp4 for maximum compatibility
const supportedAudioFileTypes = [
  '.aac',
  '.flac',
  '.m4a',
  '.mp3',
  '.mp4',
  '.mov',
  '.ogg',
  '.wav',
  '.webm',
  '.3gp',
  '.amr'
];

export { supportedAudioFileTypes }; 